import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { RoleType } from '../constants-types/Enums';
import { SiteNavigationService } from '../core-services/SiteNavigation.service';
import { ModuleAccessService } from '../system-services';
import { FeatureFlagsService } from '../system-services/FeatureFlags.service';
import { InitDataService } from '../system-services/InitData/InitData.service';

export type HasPermissionLevelGuardData = {
    hasPermissionLevel: {
        redirectTo?: (route: ActivatedRouteSnapshot) => string;
        roleType: RoleType;
        hasAdditionalAuthorization?: (
            initData: InitDataService,
            featureFlags?: FeatureFlagsService,
            moduleAccess?: ModuleAccessService
        ) => boolean;
    };
};

@Injectable({ providedIn: 'root' })
export class HasPermissionLevelGuard {
    constructor(
        private router: Router,
        private initData: InitDataService,
        public siteNavigation: SiteNavigationService,
        public featureFlags: FeatureFlagsService,
        public moduleAccess: ModuleAccessService
    ) {}
    canActivate(route: ActivatedRouteSnapshot) {
        const data = route.data as HasPermissionLevelGuardData;

        // if the user has a certain roleType and if the hasAdditionalAuthorization function is defined then logic within that function must also pass
        if (
            !this.initData.hasPermissionLevelOrAbove(
                data.hasPermissionLevel.roleType
            ) ||
            (data.hasPermissionLevel.hasAdditionalAuthorization &&
                !data.hasPermissionLevel.hasAdditionalAuthorization(
                    this.initData,
                    this.featureFlags,
                    this.moduleAccess
                ))
        ) {
            const redirectTo =
                data.hasPermissionLevel.redirectTo !== undefined
                    ? data.hasPermissionLevel.redirectTo(route)
                    : '/';
            if (this.siteNavigation.isInDesign) {
                window.location.assign(
                    window.location.protocol +
                        '//' +
                        window.location.host +
                        redirectTo
                );
            } else {
                this.router.navigate([redirectTo]);
            }

            return false;
        }
        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot) {
        return this.canActivate(route);
    }
}
